import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-compass-3-line text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-semibold text-background-50 whitespace-nowrap">
                  {siteInfo.name}
                </span>
              </div>
              <p className="text-sm text-background-50/60 leading-relaxed">
                {siteInfo.description.substring(0, 80)}...
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                内容分类
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                更多分类
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                  >
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                联系我们
              </h4>
              <div className="space-y-3">
                <a
                  href={siteInfo.socialLinks.telegram}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-background-50/60 hover:text-background-50 transition-colors"
                >
                  <i className="ri-telegram-line"></i>
                  <span>Telegram 频道</span>
                </a>
                <a
                  href={siteInfo.socialLinks.twitter}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-background-50/60 hover:text-background-50 transition-colors"
                >
                  <i className="ri-twitter-x-line"></i>
                  <span>Twitter / X</span>
                </a>
                <a
                  href={siteInfo.socialLinks.email}
                  className="flex items-center gap-2 text-sm text-background-50/60 hover:text-background-50 transition-colors"
                >
                  <i className="ri-mail-line"></i>
                  <span>{siteInfo.contactEmail}</span>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
            </p>
            <p className="text-xs text-background-50/40">
              本站为非官方网站，仅提供 caoliu 相关导航和使用指南信息
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}